/**
 * Local Storage 的 key 值
 */
export enum LocalStorageKey {
  /** 使用者最後使用的語系 */
  LOCALE = 'locale',
  /** 使用者資訊 */
  USER_PROFILE = 'userProfile'
}
